import { CUSTOM_EVENTS } from '../../../../../client/constants/communication-custom-events';
import { appConfig as $config } from '../app.config';

import { Common } from './Common';
import { UI } from './UI';
import { User } from './User';
import { SortFilter } from './SortFilter';
import { ClientTimeOut } from './ClientTimeOut';

export const App = (function () {
  $.xhrPool = []; // Очередь запросов AJAX
  let $dataPool = [],
    $dataPoolRequestPage;

  let init = () => {
    dataBinder.autoBind = false;
    ajaxSetapInit();
    getLangSource();

    // Inactivity client timeout
    // TODO For testing only. Remove after that
    let paramTimer = Common.gup('logouttimer');
    paramTimer = paramTimer ? paramTimer * 60 * 1000 : false;
    ClientTimeOut.init(paramTimer ? paramTimer : $config.clientTimeOut);

    Common.init();
    UI.init();

    //Init WebSocket Layer
    // WS.init();

    window.addEventListener('react:accountreload:complete', () => User.setAccountReload());
  };

  let ajaxData = (
    pathname,
    data = {},
    type = 'GET',
    contentType = 'application/json',
    customResponse,
    responseMapper,
    skipFilters
  ) => {
    // Request out from our API
    let outFromAPI = pathname.startsWith('http');
    // TODO make all responses with our structure: {isSuccess: ..., errorInformation: ...}
    let systemPath =
      outFromAPI ||
      pathname.startsWith('system') ||
      pathname.startsWith('/system') ||
      pathname.startsWith('defaults') ||
      pathname.startsWith('/defaults') ||
      pathname.startsWith('blank') ||
      pathname.startsWith('/blank'); // This response hasnt isSuccess

    let artworkStatProcess = pathname.startsWith('/artworks/checkstateartworksprocess/');

    let ignoreErrorHandler = pathname.startsWith('prelistings/submit-colorgate/');

    if (type.toUpperCase() == 'POST' && !skipFilters) {
      data = SortFilter.prepareQuery(data);
    }

    $dataPool.push(data);

    const fetchData = (requestData) =>
      new Promise((resolve, reject) => {
        let options = {
          url: (!outFromAPI ? $config.apiURL : '') + pathname, // - Request out from our API
          type: type,
          data: type == 'GET' ? data : JSON.stringify(requestData),
          traditional: true,
          dataType: 'json',
          contentType: contentType,
          crossDomain: true,
          async: true,
          headers: !outFromAPI ? ajaxHeaders(requestData) : {}, // - Request out from our API
          success: function (res, textStatus, jqXHR) {
            try {
              let responseData = typeof res == 'object' ? res : $.parseJSON(res);

              let index = $.xhrPool.indexOf(jqXHR);
              if (index > -1) {
                // Set request pageNum to response
                if ($dataPool.length && $dataPool[index] && $dataPool[index].page != undefined) {
                  responseData.page = $dataPool[index].page;
                  if ($dataPool[index].requestPage) {
                    responseData.requestPage = $dataPool[index].requestPage;
                  }
                }

                $dataPool.splice(index, 1);

                $.xhrPool.splice(index, 1);
              }

              if (typeof responseMapper === 'function') {
                responseData = responseMapper(responseData);
              }

              if (responseData.requestPage) {
                // Clear Filters IF page chenged
                if ($dataPoolRequestPage != responseData.requestPage) {
                  if ($dataPoolRequestPage) {
                    SortFilter.clear($dataPoolRequestPage);
                  }

                  $dataPoolRequestPage = responseData.requestPage;
                }
              }

              // Filters structure
              if (responseData.filterData) {
                SortFilter.prepare(responseData.filterData, responseData.requestPage);
              }

              responseData = Common.responsePrepare(responseData);

              if (responseData.data?.length === 0 && requestData.page - 1 > 0) {
                const newData = { ...requestData, page: requestData.page - 1 };
                let newResponseData;

                return fetchData(newData)
                  .then((res) => {
                    newResponseData = res;
                  })
                  .finally(() => resolve(newResponseData));
              }
              return resolve(responseData);
            } catch (err) {
              return resolve(res);
            }
          },
          error: function (jqXHR, exception) {
            let msg = '';
            if (artworkStatProcess && jqXHR.status == 503) {
              return resolve({ reason: '503' });
            }
            if (jqXHR.statusText == 'abort') {
              return reject();
            }

            if (jqXHR.status === 0) {
              msg = 'Not connect.\n Verify Network.';
            } else if (jqXHR.status == 404) {
              msg = 'Requested page not found. [404]';
            } else if (jqXHR.status == 302) {
              // Login Require
              window.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.LOGOUT_ACTION));
              return;
              // return User.unauthorizedHandler();
            } else if (jqXHR.status == 500) {
              msg = 'Internal Server Error [500].';
            } else if (exception === 'parsererror') {
              msg = 'Requested JSON parse failed.';
            } else if (exception === 'timeout') {
              msg = 'Time out error.';
              /*} else if (exception === 'abort') {
            msg = 'Ajax request aborted.';*/
            } else if (jqXHR.status == 403) {
              msg = 'Access denied';
            } else {
              msg = 'Uncaught Error.\n' + jqXHR.responseText;
            }

            if (updateAPIVersion(jqXHR)) {
              User.unauthorizedHandler();
              return reject(msg);
            }

            UI.errorMessage(msg);
            return reject(msg);
          }
        };

        $.ajax(options).always(function (res, status, request) {
          if (updateAPIVersion(res, request)) {
            return User.unauthorizedHandler();
          }

          if (typeof responseMapper === 'function') {
            res = responseMapper(res);
          }

          if (status == 'abort') {
            return reject();
          }

          if (res.status == 401) {
            return User.unauthorizedHandler();
          }

          if (res.status == 403) {
            return reject(res);
          }

          if (ignoreErrorHandler) {
            return reject(res);
          }

          if (
            !res.isSuccess &&
            !systemPath &&
            !artworkStatProcess &&
            !res.validationErrors &&
            !(res.errorInformation?.errorDataType === 'Specific') &&
            !customResponse
          ) {
            let txt =
              res.errorInformation && res.errorInformation.errorReason
                ? res.errorInformation.errorReason
                : 'Unknown error';
            UI.errorMessage(txt);
            return reject(res);
          }
        });
      });

    return fetchData(data);
  };

  let updateAPIVersion = (res, request) => {
    let apiVersion;

    // App version
    if ($.isPlainObject(request) && request.getResponseHeader('brandbow-api-version')) {
      apiVersion = request.getResponseHeader('brandbow-api-version');

      App.pageData('brandbowApiVersion', apiVersion);
      // Pass to react app
      window.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.CHANGE_API_VERSION, { detail: { apiVersion } }));
    }

    if (!apiVersion) {
      apiVersion = res.getResponseHeader('brandbow-api-version');
    }

    if (!apiVersion) {
      return false;
    }

    const storedApiVersion = $storage.get($config.storagekey.brandbowApiVersion);

    return storedApiVersion !== apiVersion;
  };

  let ajaxHeaders = (data) => {
    let headers = {};
    let bbw_auth = $storage.get($config.storagekey.userauth);
    let bbw_select_account_id = $storage.get($config.storagekey.selectaccountid);
    if (data && data.user && data.password) {
      headers.Authorization = `Basic ${btoa(data.user + ':' + data.password)}`;
    } else if (bbw_auth) {
      headers.Authorization = `Bearer ${bbw_auth}`;
    }

    if (bbw_select_account_id) {
      headers.SelectAccountId = bbw_select_account_id;
    }

    return headers;
  };

  let getLangSource = () => {
    if (window.$Lang) {
      window['$lang'] = $Lang;
    } else {
      swal.fire('No language file found!', 'Please reload the page.', 'error');
    }
  };

  let getSelectionFromApi = (accountId, keys = []) => {
    return ajaxData(`/selection/${accountId}?${$.param({ keys: keys }, true)}`);
  };

  let getSubmenuItemsFromApi = (accountId, keys = []) => {
    return ajaxData(`/defaults/getsubmenuitems/${accountId}?${$.param({ keys: keys }, true)}`);
  };

  let ajaxFileContent = (path) => {
    return new Promise((resolve, reject) => {
      $.get(path, (res) => resolve(res), 'html')
        .done((res) => resolve(res))
        .fail(reject);
    });
  };

  /* -  Get / Set Page data for DataBinding
   ***************************************************/
  let pageData = (
    field = null, // Имя поля, если не указано - глобальный скоп данных страницы.
    // Для вложенного указывать с точкой: "Permissions.Categories".
    // Если поля не существует, будет создано.
    data = null // Данные для поля,
    // если хотим очистить - 'clear'
  ) => {
    let clear = false;
    if ($.isPlainObject(field)) {
      data = field;
      field = false;
    }
    if (data === 'clear') {
      clear = true;
    }

    if (!window[$config.pagedatakey.root]) window[$config.pagedatakey.root] = new Object();
    let sectionPath = 'window.' + $config.pagedatakey.root;

    if (field) {
      let sectArr = field.split('.');
      for (let i = 0; i < sectArr.length; i++) {
        sectionPath += '.' + sectArr[i];
        if (!eval(sectionPath) && i < sectArr.length - 1) {
          if (typeof data == 'object') {
            if (Array.isArray(data)) eval(sectionPath + '= []');
            else eval(sectionPath + '= {}');
          }
        }
      }
    }

    if (data !== null) {
      eval(sectionPath + '=null');
      if (!clear) eval(sectionPath + '=data');
    }

    let out = eval(sectionPath);

    if (typeof out == 'object') {
      if (Array.isArray(out)) {
        return normalizeArray(out);
      }

      return normalizeObject(out);
    }

    return out;
  };

  let normalizeObject = (obj) => {
    let newObj = {};
    $.each(obj, function (k, val) {
      if (typeof val == 'object') {
        if (Array.isArray(val)) {
          newObj[k] = normalizeArray(val);
        } else {
          newObj[k] = JSON.parse(JSON.stringify(val));
        }
      } else if (typeof val != 'function') {
        newObj[k] = val;
      }
    });
    return newObj;
  };

  let normalizeArray = (obj) => {
    let newArr = [];
    $.each(obj, function (k, val) {
      if (typeof val != 'function') {
        newArr[k] = val;
      }
    });
    return JSON.parse(JSON.stringify(newArr));
  };

  let pageDataInit = (data, start = false) => {
    let transferData = {
      $lang: window['$lang']
    };
    if (start) {
      transferData = {
        ...transferData,
        ...{
          brandbowApiVersion: App.pageData('brandbowApiVersion'),
          userAccounts: User.accountsData(),
          userdata: User.userContext(),
          ACNT: User.accountData(),
          totalCount: App.pageData('totalCount') || 0
        }
      };
    } else {
      transferData = {
        ...transferData,
        ...{
          brandbowApiVersion: App.pageData('brandbowApiVersion'),
          userAccounts: App.pageData('userAccounts'),
          userdata: App.pageData('userdata'),
          ACNT: App.pageData('ACNT'),
          totalCount: App.pageData('totalCount')
        }
      };
    }
    window['DT'] = null;
    pageData({
      ...data,
      ...transferData
    });
  };

  /*
   ** -  Очередь AJAX запросов
   */
  let ajaxSetapInit = () => {
    $.ajaxSetup({
      beforeSend: function (jqXHR) {
        // before jQuery send the request we will push it to our array
        $.xhrPool.push(jqXHR);
      },
      complete: function (jqXHR) {
        // when some of the requests completed it will splice from the array
      }
    });
  };

  /*
   ** -  Прервать все активные AJAX запросы
   */
  let ajaxAbortAll = () => {
    $.each($.xhrPool, function (idx, jqXHR) {
      jqXHR.abort();
    });
    $.xhrPool.length = 0;
    $dataPool = [];
  };

  return {
    init,
    ajaxData,
    ajaxFileContent,
    pageData,
    pageDataInit,
    ajaxAbortAll,
    getSelectionFromApi,
    getSubmenuItemsFromApi,
    ajaxHeaders
  };
})();
